  export const getColour = (key: string, data: boolean = false) => {
    const k = key.toLocaleLowerCase();
    switch (k) {
      case "partners":
        return data ? "#004a59" : "#CCFFF6";
      case "consumer":
      case "onlinebrands":
        return data ? "#D600C4" : "#FFCCEA";
      case "p2p":
        return data ? "#FFAA00" : "#FFF1D6";
      case "checkout- moneygram":
        return "rgb(228, 35, 19)"
      case "checkout- ain":
        return "rgb(149, 193, 31)";
      case "digicel":
        return data ? "#E62600" : "#FFB3A6";
      case "b2b":
        return data ? "#004A59" : "#599EFF";
      case "checkout- western union":
      case "checkout- western union eu":
      case "whitelabel":
        return "rgb(0,0,0)";
      case "dingmoney":
        return data ? "#001273" : "#CCFFF6";
    }
    return "#004a59";
  };